export default __webpack_public_path__ + "205016f2a569f117053eaa26b26d5b0f.png";